import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import {
  FaIndustry,
  FaChartLine,
  FaRocket,
  FaHandsHelping,
  FaEye,
} from "react-icons/fa";
import "./service.css";
import { useNavigate } from "react-router-dom";

const servicesData = [
  {
    title: "Smart Manufacturing Solutions",
    icon: <FaIndustry size={40} className="text-warning" />,
    description:
      "With a dedicated support system, each service request is tracked and managed, ensuring that a specific service personnel is assigned to resolve the issue. This personalized approach guarantees that every customer receives attention tailored to their specific needs, making them feel valued and cared for.",
    route: "/smart-manufacturing",
  },
  {
    title: "EZYMPS",
    icon: <FaChartLine size={40} className="text-success" />,
    description:
      "Our ERP system ensures that every service request is recorded, with real-time updates on progress. This level of tracking provides transparency and builds trust with customers, who can monitor the status of their service request from start to finish, ensuring complete accountability.",
    route: "/ezymps-page",
  },
  {
    title: "Our Export Services",
    icon: <FaRocket size={40} className="text-danger" />,
    description:
      "By integrating a streamlined service management system, businesses benefit from faster response times and optimized resource allocation. The system ensures that no service request is overlooked and that service personnel are always deployed effectively, leading to reduced downtime and higher productivity.",
    route: "/export-import",
  },
  {
    title: " Our Trading Expertise",
    icon: <FaHandsHelping size={40} className="text-info" />,
    description:
      "Our customer support team is available around the clock to address your concerns and provide timely assistance, ensuring a seamless and satisfying service experience at all times.",
    route: "/innovative-trading",
  },
];

const Services = () => {
  const navigate = useNavigate();

  return (
    <div
      className="py-5"
      style={{ backgroundColor: "#f5f8ff", overflow: "hidden" }}
    >
      <Container>
        <Row className="mb-5">
          <Col>
            <h2 className="title-font" data-aos="fade-up">
              Why Choose Our Service?
            </h2>
          </Col>
        </Row>
        <Row className="g-4 justify-content-center">
          {servicesData.map((service, idx) => (
            <Col
              key={idx}
              sm={6}
              md={6}
              lg={6}
              data-aos="zoom-in"
              data-aos-delay={idx * 100}
            >
              <Card
                className="card-hover-zoom text-center h-100 border-0 shadow rounded-4 p-4 bg-white d-flex justify-content-center align-items-center"
                onClick={() => {
                  navigate(service.route);
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
                style={{ cursor: "pointer" }}
              >
                <div className="mb-3 icon-circle">{service.icon}</div>
                <div className="fw-bold text-dark fs-6 mb-1">
                  {service.title}
                </div>
                <Card.Text className="text-muted fs-13">
                  {service.description.length > 450
                    ? `${service.description.substring(0, 450)}...`
                    : service.description}
                </Card.Text>
                <div>
                  <button
                    className="btn btn-sm btn-custom-outline mt-2"
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(service.route);
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                  >
                    View More
                  </button>
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default Services;
